import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./index.scss";
import { Modal } from "react-bootstrap";
import backicon from "../../../../../Assets/icons/backIcon.svg";
import downloadIcon from "../../../../../Assets/icons/download.svg";
import plusIcon from "../../../../../Assets/icons/plus-circle.svg";
import MinusIcon from "../../../../../Assets/icons/Minus-circle.svg";
import axiosInstance from "../../../../services/api/API";
import moment from "moment";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";

//plus-circle.svg Minus-circle.svg

const SparePartAllocationDetails = () => {
  const location = useLocation();
  const { data } = location?.state || {};
  const [jobCardDetails, setJobCardDetails] = useState(null);
  const [jobCardIssueList, setJobCardIssueList] = useState([]);
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [selectedAssignee, setSelectedAssignee] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [showRemarkModal, setShowRemarkModal] = useState(false); // Add state for remark modal
  const [remark, setRemark] = useState("");
  const [formData, setFormData] = useState({});
  const [itemList, setItemList] = useState([]);
  const [approveModel, setApproveModel] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  // Add state for remark
  const [assigneeList] = useState([
    { name: "Telecaller 1", assignedLeads: 5 },
    { name: "Telecaller 2", assignedLeads: 10 },
    { name: "Telecaller 3", assignedLeads: 3 },
    { name: "Sales Manager 1", assignedLeads: 8 },
    { name: "Sales Manager 2", assignedLeads: 6 },
    { name: "Sales Manager 3", assignedLeads: 2 },
  ]);
  const [issueId, setIssueId] = useState(0);

  const [filteredAssigneeList, setFilteredAssigneeList] =
    useState(assigneeList);

  const PartInputs = [
    {
      name: "item",
      label: "Item Type",
      type: "dropdown",
      options: itemList || [],
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },

    {
      name: "request_qty",
      label: "Request Qty",
      type: "dropdown",
      options:
        [
          {
            label: "1",
            value: 1,
          },
          {
            label: "2",
            value: 2,
          },
          {
            label: "3",
            value: 3,
          },
          {
            label: "4",
            value: 4,
          },
          {
            label: 5,
            value: 5,
          },
        ] || [],
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "part_allotment",
      label: "Part Allotment",
      type: "dropdown",
      options:
        [
          {
            label: "Allocated",
            value: "Y",
          },
          {
            label: "UnAllocated",
            value: "N",
          },
        ] || [],
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
  ];

  const onClickSetIssueId = async (details) => {
    console.log("asdas", details);
    setFormData({
      item_name: details?.item_name,
      item_type: details?.itemtype,
      good_belance: details?.good_balance,
      request_qty: details?.good_qty,
      part_allotment: details?.is_part_allocated,
      business_partner_id: details?.business_partner_id,
      job_card_id: details?.job_card_id,
      part_detail_id: details?.part_detail_id,
      item: details?.item_id,
    });
    try {
      const response = await axiosInstance.post(
        "/sparepartallocation/sparepartitems",
        {
          business_partner_id: details?.business_partner_id,
          itemtype_id: details?.item_type_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.status == 200) {
        console.log(response?.data?.data);
        const itemListData = response?.data?.data?.data?.map(
          (itemDetails, index) => ({
            label: itemDetails?.item_name,
            value: itemDetails?.item_id,
          })
        );
        setItemList(itemListData);
        setApproveModel(true);
      }

      // setJobCardDetails(formattedData[0])
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };
  const assigneeTypeFilter =
    modalType === "Telecaller" ? "Telecaller" : "Sales Manager";
  const filteredAssignees = assigneeList.filter((assignee) =>
    assignee.name.includes(assigneeTypeFilter)
  );

  const fetchJobCardIssueList = async (page = 0, pageSize = 1) => {
    try {
      const response = await axiosInstance.post(
        "/jobcard/jobcardview",
        {
          business_partner_id: data?.business_partner_id?data?.business_partner_id 
          : 1,
          job_card_id: data?.job_card_id,
          login_user_id: null,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response.data.data.map((item, index) => ({
        ...item,
      }));
      setJobCardDetails(formattedData[0]);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const fetchJobCardDetails = async (page = 0, pageSize = 1) => {
    try {
      const response = await axiosInstance.post(
        "/jobcard/getservicesdetails",
        {
          business_partner_id: data?.business_partner_id || 1,
          job_card_id: data?.job_card_id,
          login_user_id: null,
          Type: "SparePartAllocationView",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const formattedData = response.data.data.map((item, index) => ({
        ...item,
        //"Sr_No": index + 1,
        //:item?.solved === 0 ? 'Pending': 'Done',
        // job_card_no:onClickNavigetion(item)
      }));
      setJobCardIssueList(formattedData);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const handleFormSubmit = async (data) => {
    try {
      const response = await axiosInstance.post(
        "/sparepartallocation/sparepartallocationitemupdate",
        {
          part_detail_id: data?.part_detail_id,
          business_partner_id: data?.business_partner_id,
          job_card_id: data?.job_card_id,
          item_id: data?.item,
          good_qty: data?.request_qty,
          is_part_allocated: data?.part_allotment,
          updated_by: 35,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setApproveModel(false);
      fetchJobCardDetails();
      fetchJobCardIssueList();
      // const formattedData = response.data.data.map((item, index) => ({
      //     ...item,
      //     //"Sr_No": index + 1,
      //     //:item?.solved === 0 ? 'Pending': 'Done',
      //     // job_card_no:onClickNavigetion(item)

      // }))
      // setJobCardIssueList(formattedData)
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  useEffect(() => {
    if (data) {
      fetchJobCardDetails();
      fetchJobCardIssueList();
    }
  }, []);
  
  const backNavigate = () => {
    navigate("/manage-services/spare-part-allocation");
  };

  return (
    <div className="container-fuiled">
      <div className="OnboardManagamentContainer  mt-2 ">
        <span className="backbtntitle">
          <img src={backicon} alt="back" style={{ marginRight: 5 }} onClick={()=>{backNavigate()}}/> Job Card
          Details
        </span>
      </div>
      <div className="container-fuiled row  ">
        <div className="col-5 vechalDetails">
          <h5 className="m-3">Vehiclel Details</h5>
          <div>
            <div className="vechal-Details-SubView m-3 ">
              <div className="details-item">
                <span className="details-label">Job Card No.</span>
                <span className="details-value">
                  {jobCardDetails?.job_card_no || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Job Card Date</span>
                <span className="details-value">
                  {moment(jobCardDetails?.transaction_date).format(
                    "MM/DD/YYYY"
                  )}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Customer name</span>
                <span className="details-value">
                  {jobCardDetails?.customer_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Mobile No.</span>
                <span className="details-value">
                  {jobCardDetails?.contact_no || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Reg. No.</span>
                <span className="details-value">
                  {jobCardDetails?.registration_no || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Chassis No.</span>
                <span className="details-value">
                  {jobCardDetails?.chassis_no || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Engine No.</span>
                <span className="details-value">
                  {jobCardDetails?.engineno || "-"}
                </span>
              </div>
              {/* <div className="details-item">
                <span className="details-label">PIN Code</span>
                <span className="details-value">
                  {jobCardDetails?.pincode || "-"}
                </span>
              </div> */}

              <div className="details-item">
                <span className="details-label">Product Name</span>
                <span className="details-value">
                  {jobCardDetails?.product_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Sub Product Name</span>
                <span className="details-value">
                  {jobCardDetails?.subproduct_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Make</span>
                <span className="details-value">
                  {jobCardDetails?.make_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Model</span>
                <span className="details-value">
                  {jobCardDetails?.model_name || "-"}{" "}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Variant</span>
                <span className="details-value">
                  {jobCardDetails?.variant_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Variant Color</span>
                <span className="details-value">
                  {jobCardDetails?.color_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Fuel Type</span>
                <span className="details-value">
                  {jobCardDetails?.fuel_type_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Warranty Start Date</span>
                <span className="details-value">
                  {jobCardDetails?.warranty_startdate || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Warranty End Date</span>
                <span className="details-value">
                  {moment(jobCardDetails?.warranty_enddate).format(
                    "DD/MM/YYYY"
                  ) || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Warranty Period</span>
                <span className="details-value">
                  {moment(jobCardDetails?.warranty_period).format(
                    "DD/MM/YYYY"
                  ) || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Supervisor</span>
                <span className="details-value">
                  {jobCardDetails?.supervisor_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Allocation Date</span>
                <span className="details-value">
                  {moment(jobCardDetails?.allocation_date).format(
                    "DD/MM/YYYY"
                  ) || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Job Estimate Amt.</span>
                <span className="details-value">
                  {jobCardDetails?.job_estimate_amount || 0}
                </span>
              </div>

              <div className="details-item">
                <span className="details-label">Job Status</span>
                <span className="details-value">
                  {jobCardDetails?.status == 0 ? "Pending" : "Done"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Signature</span>
                <div style={{ display: "flex", gap: 5 }}>
                  <img
                    src={jobCardDetails?.signature_path}
                    style={{ height: 30, width: 50 }}
                  />
                  <span className="details-value">Verify</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-7">
          <div className="addButtonStyle">
            <h5 className="m-3" >List Details</h5>
          </div>
          {(jobCardIssueList || [])?.map((issueDetails) => (
            <div className="issue-Details-SubView">
              <div className="details-item">
                <span className="details-label">Item Name:</span>
                <span className="details-value">
                  {issueDetails?.item_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Item type :</span>
                <span className="details-value">
                  {issueDetails?.itemtype || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">item:</span>
                <span className="details-value">
                  {issueDetails?.tech_item_name || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Request Quantity:</span>
                <span className="details-value">
                  {issueDetails?.good_qty || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Goods Balance:</span>
                <span className="details-value">
                  {issueDetails?.good_balance || "-"}
                </span>
              </div>
              <div className="details-item">
                <span className="details-label">Part Allotment Status:</span>
                <span className="details-value">
                  {issueDetails?.is_part_allocated == "Y"
                    ? "Allocated"
                    : "UnAllocated"}
                </span>
              </div>

              <div
                onClick={() => {
                  onClickSetIssueId(issueDetails);
                }}
              >
                <img
                  src={plusIcon}
                  // alt={isAccordionExpanded(parentMenu.parentId) ? 'Expanded' : 'Collapsed'}
                  className="accordion-icon"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
      <Modal
        show={approveModel}
        onHide={() => setApproveModel(false)}
        centered
        size="lg"
        //  className="large"
      >
        <Modal.Header closeButton>
          <Modal.Title> Part Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DynamicForm
            formConfig={PartInputs || []}
            formData={formData}
            setFormData={setFormData}
            onSubmit={handleFormSubmit}
            validationErrors={validationErrors}
            setValidationErrors={setValidationErrors}
          />

          <div className="btncontainer mt-3">
            <button
              onClick={() => {
                handleFormSubmit(formData);
              }}
              className="submit-btn"
            >
              {"Submit"}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SparePartAllocationDetails;
